import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RSA_NO_PADDING } from 'constants';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { TemplateFileService } from 'src/app/core/services/template-file.service';
import { DocumentDownloadDialogComponent } from 'src/app/shared/components/document-download-dialog/document-download-dialog.component';
import { DocumentTemplate } from 'src/app/shared/models/document-template.model';
import { DialogPreviewPdfComponent } from '../dialog-preview-pdf/dialog-preview-pdf.component';
import { DomSanitizer } from '@angular/platform-browser';
import { CommonService } from 'src/app/core/services/common.service';
import { forkJoin } from 'rxjs';
import { Message } from "src/app/core/class/message";
import { ToastrService } from 'ngx-toastr';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { ENT_TYPE } from 'src/app/core/constants/common';
import { finalize } from 'rxjs/operators';
import { DocumentTemplateService } from 'src/app/core/services/document-template.service';
import { Router } from '@angular/router';
import { DocumentDownloadFalseDialogComponent } from 'src/app/shared/components/document-download-false-dialog/document-download-false-dialog.component';
@Component({
  selector: 'app-search-document-template',
  templateUrl: './search-document-template.component.html',
  styleUrls: ['./search-document-template.component.scss']
})
export class SearchDocumentTemplateComponent implements OnInit {
  systemPaginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  syncPaginate: {
    currentPage: number,
    pageSize: number,
    totalRow: number,
    totalPage: number,
    totalPageArray: [],
    no: []
  };
  isShowChangeRecordOfPage = false
  systemFormGroup: FormGroup = new FormGroup({
    name: new FormControl(''),
    realm: new FormControl(''),
  });
  syncFormGroup: FormGroup = new FormGroup({
    name: new FormControl(''),
  });
  listRealms = [];
  systemTemplates = [];
  syncTemplates = [];
  systemTmlp = { $implicit: { list: this.systemTemplates, paginate: null, formGroup: this.systemFormGroup } }
  syncTmlp = { $implicit: { list: this.syncTemplates, paginate: null, formGroup: this.syncFormGroup } }
  image: Record<string, any> = {};
  imageUrl: any
  listRealmOptions = [];
  currentTab = 0;
  syncAccount = 'vContract';
  isAdminDefault = false;
  isMultiUser = false;
  isBuyTwoService = false;
  total = 0;
  constructor(
    public dialogRef: MatDialogRef<SearchDocumentTemplateComponent>,
    private documentTypeService: DocumentTypeService,
    private documentTemplateService: DocumentTemplateService,
    private templateFileService: TemplateFileService,
    private dialog: MatDialog,
    private toast: ToastrService,
    private message: Message,
    private router: Router,
    private commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public response: any,
  ) {
    const userService = JSON.parse(localStorage.getItem('userServices') || '[]');
    if (userService && userService.length >= 2) {
      this.isMultiUser = true;
    }

    this.isAdminDefault = this.commonService.checkDefaultAdmin();
    const paginateDefault = {
      currentPage: 0,
      pageSize: 10,
      totalRow: 0,
      totalPage: 0,
      totalPageArray: [],
      no: [],
    };
    paginateDefault.totalPageArray = this.counter(Math.ceil(paginateDefault.totalRow / paginateDefault.pageSize), 1);
    paginateDefault.no = this.counter(paginateDefault.pageSize, paginateDefault.currentPage * paginateDefault.pageSize + 1)

    this.systemPaginate = Object.assign(paginateDefault);
    this.syncPaginate = Object.assign(paginateDefault);
    this.updateTmplList('all');
    const entType = localStorage.getItem('entType');
    if (entType) {
      if (parseInt(entType) === 1) {
        this.syncAccount = ENT_TYPE[2];
      } else {
        this.syncAccount = ENT_TYPE[1];
      }
    }
    this.isBuyTwoService = this.commonService.checkBuyTwoServiceWithoutHauntAndAdmin();

  }

  ngOnInit() {
    this.getRealm();

    this.systemTemplates = this.response.systemTemplates.data.content;
    this.total = this.response.systemTemplates.data.total;
    this.updatePaginate(this.response.systemTemplates, 'systemTemplates');
    this.updateTmplList('systemTemplates');

    if (this.response.syncTemplates) {
      this.syncTemplates = this.response.syncTemplates.data.content;
      this.updatePaginate(this.response.syncTemplates, 'syncTemplates');
      this.updateTmplList('syncTemplates')
      this.getImageByUrl(this.syncTemplates);
    }

    if (this.systemTemplates && this.systemTemplates.length > 0) {
      this.getImageByUrl(this.systemTemplates);
    }
  }

  updatePaginate(data, templateType: 'systemTemplates' | 'syncTemplates') {
    const paginate = {
      currentPage: data.data.pageable.page,
      pageSize: data.data.pageable.size,
      totalRow: data.data.total,
      totalPage: Math.ceil(
        data.data.total / data.data.pageable.size
      ),
      totalPageArray: this.counter(Math.ceil(data.data.total / data.data.pageable.size), 1),
      no: this.counter(data.data.pageable.size, data.data.pageable.page * data.data.pageable.size + 1)
    };

    if (templateType === 'systemTemplates') {
      this.systemPaginate = Object.assign(paginate);
      return;
    }
    this.syncPaginate = Object.assign(paginate);
  }

  private counter(index: number, from: number): any {
    return new Array(index).fill(0).map((x, i) => i + from);
  }

  getRealm() {
    this.documentTypeService.getRealm().subscribe((result) => {
      this.listRealms = result.data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()))
      this.listRealmOptions = this.listRealms.filter(item => item.status === 'ACTIVE')
    });
  }

  loadData() {
    let body = {
      name: this.systemFormGroup.value.name,
      realm: this.systemFormGroup.value.realm,
      page: this.systemPaginate.currentPage,
      size: this.systemPaginate.pageSize
    }
    this.documentTypeService.systemGetAll(body)
      .pipe(finalize(() => {
        this.isOneAction = false;
      }))
      .subscribe(rs => {

        this.systemTemplates = rs.data.content;
        this.total = rs.data.total;
        this.getImageByUrl(this.systemTemplates);
        this.updatePaginate(rs, 'systemTemplates');
        this.updateTmplList('systemTemplates');
        this.systemFormGroup.markAsPristine();
      })
  }

  updateTmplList(templateType: 'systemTemplates' | 'syncTemplates' | 'all') {
    if (templateType === 'all') {
      this.systemTmlp = { $implicit: { list: this.systemTemplates, paginate: this.systemPaginate, formGroup: this.systemFormGroup } }
      this.syncTmlp = { $implicit: { list: this.syncTemplates, paginate: this.syncPaginate, formGroup: this.syncFormGroup } }
      return;
    }

    if (templateType === 'systemTemplates') {
      this.systemTmlp = { $implicit: { list: this.systemTemplates, paginate: this.systemPaginate, formGroup: this.systemFormGroup } }
      return;
    }

    this.syncTmlp = { $implicit: { list: this.syncTemplates, paginate: this.syncPaginate, formGroup: this.syncFormGroup } }
  }

  loadSyncData() {
    let body = {
      name: this.syncFormGroup.value.name,
      page: this.syncPaginate.currentPage,
      size: this.syncPaginate.pageSize
    }
    this.documentTypeService.syncGetAll(body)
      .pipe(finalize(() => {
        this.isOneAction = false;
      }))
      .subscribe(rs => {

        this.syncTemplates = rs.data.content;
        this.total = rs.data.total;
        this.getImageByUrl(this.syncTemplates);
        this.updatePaginate(rs, 'syncTemplates');
        this.updateTmplList('syncTemplates');
        this.syncFormGroup.markAsPristine();
      })
  }

  preview(element) {
    let api = this.templateFileService.getSystemTemplateFile(element.documentTemplateId);
    if (this.currentTab === 1) {
      api = this.templateFileService.getTemplateFile(element.documentTemplateId);
    }

    api.subscribe((res) => {
      if (res && res.code === ErrorCode.NotPermissionTemplate) {
        this.toast.error(this.message.getMessage('messages.check_permission'));
        return;
      }
      if (res.data[0]) {
        this.templateFileService.getContentFileByUrl({
          type: 'TEMPLATE_PDF',
          url: res.data[0].file.pdfUrl,
        }).subscribe((response) => {
          if (!response) {
            return;
          }
          this.dialog.open(DialogPreviewPdfComponent, {
            width: '80%',
            data: {
              file: response,
              name: element.name,
              element: element,
              sync: this.currentTab === 1
            },
          });
        });
      }
    });
  }

  onFilterData(page) {
    if (this.currentTab === 0) {
      this.systemPaginate.currentPage = page;
      this.loadData();
      return;
    }
    this.syncPaginate.currentPage = page;
    this.loadSyncData();
  }

  getImageByUrl(res) {
    let listApi = [];
    res.forEach(element => {
      listApi = [...listApi, this.templateFileService.getContentFileByUrl({
        type: 'TEMPLATE_PDF',
        url: element.thumbnailUrl,
      })]
    });
    forkJoin(listApi).subscribe((response) => {
      response.forEach((item, index) => {
        this.downLoadFile(item, 'image/jpeg', res[index]);
      })
    });
  }

  blob2Base64(blob: Blob): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = () => resolve(reader.result.toString());
      reader.onerror = error => reject(error);
    })
  }

  clearData(field: string) {
    if (this.currentTab === 0) {
      this.systemFormGroup.controls[field].patchValue(null);
      this.systemFormGroup.markAsDirty();
      return;
    }

    this.syncFormGroup.controls[field].patchValue(null);
    this.syncFormGroup.markAsDirty();
  }

  downLoadFile(data: any, type: string, template: any) {
    const blob = new Blob([data], { type });
    this.blob2Base64(blob).then(res => {
      this.image[template.id] = template.thumbnailUrl ? res : null
    }
    );
    //  this.imageUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.imageUrl) as string;

  }

  renderRealm(realmId: number): string {
    const realm = this.listRealms.find(
      (type) => type.id === realmId
    );
    if (realm && realm.name) {
      return realm.name;
    }
    return '';
  }

  onRealmChange(event) {
    this.systemFormGroup.controls['realm'].setValue(event.value);
    this.search()
  }
  onTabChanged(event) {
    if (event.index == 0) {
      this.total = this.response.systemTemplates.data.total;
      return;
    }
    this.total = this.response.syncTemplates.data.total;
  }
  isOneAction = false;
  search() {
    if (this.isOneAction) {
      return;
    }

    this.isOneAction = true;

    if (this.currentTab === 0) {
      if (!this.systemFormGroup.dirty) {
        this.isOneAction = false;
        return;
      }
      this.systemPaginate.currentPage = 0;
      this.loadData();
      return;
    }

    if (!this.syncFormGroup.dirty) {
      this.isOneAction = false;
      return;
    }
    this.syncPaginate.currentPage = 0;
    this.loadSyncData();
  }

  downloadTemplate(data) {
    this.dialog.open(DocumentDownloadDialogComponent, {
      data: data,
    });
  }

  copyTemplate(data) {
    this.documentTemplateService
      .copyDocumentTemplate(data.id, 'SYNC')
      .subscribe((response) => {
        if (response.success) {
          this.documentTemplateService.typeforUpdateDocumentPage.next('create');
          const link = `/home-enterprise/document-template/update/${response.data.id}`;
          this.router.navigateByUrl(link).then(() => {
            this.dialog.closeAll();
          });
        }
        else {
          this.dialog.open(DocumentDownloadFalseDialogComponent, {
            data: {
              message: response.message,
              code: response.code,
              name: data.name
            },
          })
        }
      });
  }

  close() {
    this.dialogRef.close()
  }
}
